import { ModalContainer, ModalContent, ModalHeader } from '@/ui/Modal/Modalv2/Modal'

import styles from './ColorTypeModal.module.scss'
import { colorTypeInfo } from '../product.constants'

export function ColorTypeModal() {
  return (
    <ModalContainer data-testid="color-field-detail-info">
      <ModalHeader>{colorTypeInfo.title}</ModalHeader>
      <ModalContent>
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{
            __html: colorTypeInfo.description,
          }}
        />
      </ModalContent>
    </ModalContainer>
  )
}
